function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  "data-name": "002-block-user",
  d: "M24.061 46.545H5.984a2 2 0 0 1-1.577-.75 2.06 2.06 0 0 1-.418-1.728 21.791 21.791 0 0 1 20.752-17.255c.167.006.334.01.5.01a13.424 13.424 0 1 0-8.023-2.671A25.647 25.647 0 0 0 .127 43.263a5.992 5.992 0 0 0 5.857 7.226h18.077a1.972 1.972 0 1 0 0-3.944zm-8.284-33.134a9.467 9.467 0 1 1 9.691 9.464 1.957 1.957 0 0 0-.224-.014c-.154 0-.309 0-.462.005a9.478 9.478 0 0 1-9.005-9.455zM46.148 33.76v-1.614a5.918 5.918 0 0 0-11.833 0v1.615a4.937 4.937 0 0 0-4.337 4.894v9.861a1.972 1.972 0 0 0 1.972 1.972h16.567a1.972 1.972 0 0 0 1.972-1.972v-9.862a4.937 4.937 0 0 0-4.341-4.894zm-5.917-3.486a1.927 1.927 0 0 1 1.969 1.872v1.578h-3.941v-1.578a1.926 1.926 0 0 1 1.973-1.872zm6.313 16.269H33.922v-7.889a.987.987 0 0 1 .986-.986h10.65a.988.988 0 0 1 .986.986zm0 0"
});

var SvgIcnProfilo = function SvgIcnProfilo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 50.5 50.5",
    fill: "#fff",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcnProfilo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_profilo.f4e1e61d.svg";
export { ForwardRef as ReactComponent };